import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "src/app/app.constants";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: "root",
})
export class ExecutiveSummaryService {
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getSeventhSection(ndaValue, brand_name): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("brand_name", brand_name);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SECTION_API.EXECUTIVE_SUMMARY}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  SendEmail(
    active_ingredient,
    brand_name,
    ndaValue,
    email,
    data
  ): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("email", email);
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SENDEMAIL.EXECUTIVE_INFO}`,
      { data },
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getEditedData(
    active_ingredient,
    brand_name,
    ndaValue,
    userIp,
    uniqnumber,
    email
  ): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("userip", userIp);
    paramsInput = paramsInput.append("uniqnumber", uniqnumber);
    paramsInput = paramsInput.append("email", email);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.GETEDITEDDATA.EXECUTIVE_INFO}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateMoleculeData(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.UPDATEMOLECULEDATA.EXECUTIVE_UPDATED_DATA}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
